import { render, staticRenderFns } from "./medkitlogYears.vue?vue&type=template&id=4bd9bc62"
import script from "./medkitlogYears.vue?vue&type=script&lang=js"
export * from "./medkitlogYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports